export default {
    data: {
        currTab: 0,
        jobs: {
            inspections: [],
            totalJobs: 0,
            startIndex: 1,
            endIndex: 10,
        },
        searchKeyword: "",
        filters: {
            jobStatus: "",
            dateOperator: "between", // "between" || "before" || "after"
            from: "",
            to: "",
            locations: [
                {
                    country: "",
                    city: "",
                },
            ],
        },
    },
    status: "uninitialized",
};